module.exports = __webpack_public_path__ + "static/media/AboutUs.622cef3d.png";